import { createAtomFamily } from 'utils/recoil'

export const lastAddressStateFamily = createAtomFamily({
  prefix: 'containers/OrderEntry/Form/ReadonlyAddressCache',
  key: 'lastAddress',
})
